import axios from 'axios'
import { Message } from 'element-ui'
import Vue from "vue"
import $loading from "@/components/loading"

Vue.use($loading)

// axios 默认get请求  可以不写参数method: 'get'

// 新接口URL前缀
const NEW_API_PREFIX = process.env.VUE_APP_NEW_API_URL || '/prod-api'

// 创建实例
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API_URL
})

var isShow = false
// request interceptor
service.interceptors.request.use(
	config => {
		// 新接口URL已包含完整路径，不需要拼旧baseURL
		if (config.url && config.url.startsWith(NEW_API_PREFIX)) {
			config.baseURL = ''
		}

		// 封装参数 是post get 通用data参数
		if(config.method == 'get'){
			config.params = config.data
			config.data = ''
		}

		isShow = false;
		isShow = config.isShow
		if (config.isShow) {
			Vue.$loading.show('拼命加载中...')
		}
		config.headers["Access-Control-Allow-Origin"] = "*"
		return config
	},
	error => {
		Vue.$loading.hide()
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	response => {
		const res = response.data
		if (res.code !== 'v' && res.code !== 'pglist' && res.code !== '200') {
			if (res.code == 401) {
				Vue.$loading.hide()
				Message({
					message: res.msg || '请求失败',
					type: 'error',
					duration: 5 * 1000
				})
				return Promise.reject(new Error(res.msg || '请求失败'))
			} else {
				Message({
					message: res.msg || '请求失败',
					type: 'error',
					duration: 5 * 1000
				})
				Vue.$loading.hide()
				return Promise.reject(new Error(res.msg || '请求失败'))
			}

		} else {
			Vue.$loading.hide()
			return res
		}
	},
	error => {
		Message({
			message: error.msg,
			type: 'error',
			duration: 5 * 1000
		})
		Vue.$loading.hide()
		return Promise.reject(error)
	}
)

export default service
